var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "conversation-analytics" },
    [
      _c("a-spin", { attrs: { spinning: _vm.loading } }, [
        !_vm.loading && _vm.data && _vm.data.conversation_analytics
          ? _c("div", [
              _c("div", { staticClass: "toolbar" }, [
                _c(
                  "div",
                  { staticClass: "buttons" },
                  [
                    _c(
                      "IconButton",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: { content: "Grafik Görünümü" },
                            expression: "{ content: 'Grafik Görünümü' }",
                          },
                        ],
                        attrs: {
                          classNames:
                            _vm.viewMode === "chart" ? "selected" : "",
                          onClick: function () {
                            return (_vm.viewMode = "chart")
                          },
                        },
                      },
                      [_c("md-icon", [_vm._v("insights")])],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "IconButton",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: { content: "Pasta Grafik" },
                            expression: "{ content: 'Pasta Grafik' }",
                          },
                        ],
                        attrs: {
                          classNames: _vm.viewMode === "pie" ? "selected" : "",
                          onClick: function () {
                            return (_vm.viewMode = "pie")
                          },
                        },
                      },
                      [_c("md-icon", [_vm._v("donut_small")])],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "IconButton",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: { content: "Tablo Görünümü" },
                            expression: "{ content: 'Tablo Görünümü' }",
                          },
                        ],
                        attrs: {
                          classNames:
                            _vm.viewMode === "table" ? "selected" : "",
                          onClick: function () {
                            return (_vm.viewMode = "table")
                          },
                        },
                      },
                      [_c("md-icon", [_vm._v("table_view")])],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "IconButton",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: { content: "Excel İndir" },
                            expression: "{ content: 'Excel İndir' }",
                          },
                        ],
                        attrs: { onClick: _vm.exportToExcel },
                      },
                      [_c("md-icon", [_vm._v("download")])],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "stats-row" },
                [
                  _c("StatCard", {
                    attrs: {
                      title: "Toplam Konuşma",
                      value: _vm.totalConversations,
                      unit: "konuşma",
                    },
                  }),
                  _vm._v(" "),
                  _c("StatCard", {
                    attrs: {
                      title: "Toplam Maliyet",
                      value: _vm.totalCost.toFixed(2),
                      unit: "$",
                    },
                  }),
                  _vm._v(" "),
                  _c("StatCard", {
                    attrs: {
                      title: "Ortalama Maliyet",
                      value: _vm.avgCostPerConversation.toFixed(4),
                      unit: "$/konuşma",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "category-breakdown" }, [
                _c("h3", [_vm._v("Kategori Bazlı Dağılım")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "category-cards" },
                  _vm._l(_vm.categoryBreakdown, function (value, category) {
                    return _c(
                      "div",
                      { key: category, staticClass: "category-card" },
                      [
                        _c("div", { staticClass: "category-name" }, [
                          _vm._v(_vm._s(_vm.getCategoryLabel(category))),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "category-value" }, [
                          _vm._v(_vm._s(value.conversations) + " konuşma"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "category-cost" }, [
                          _vm._v("$" + _vm._s(value.cost.toFixed(2))),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ]),
              _vm._v(" "),
              _vm.viewMode === "chart"
                ? _c(
                    "div",
                    { staticClass: "chart-container" },
                    [
                      _c("StackedAreaChart", {
                        attrs: {
                          title: "Konuşma İstatistikleri",
                          "x-axis-data": _vm.getXAxisData(),
                          legends: _vm.getCategoryLegends(),
                          colors: _vm.categoryColors,
                          series: _vm.getCategorySeries(),
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.viewMode === "pie"
                ? _c(
                    "div",
                    { staticClass: "pie-container" },
                    [
                      _c("PieChartV2", {
                        attrs: {
                          title: "Kategori Dağılımı",
                          legends: _vm.getCategoryLegends(),
                          series: _vm.getPieSeries(),
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.viewMode === "table"
                ? _c(
                    "div",
                    { staticClass: "table-container" },
                    [
                      _c("a-table", {
                        attrs: {
                          columns: _vm.columns,
                          "data-source": _vm.tableData,
                          pagination: { pageSize: 10 },
                          size: "middle",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ])
          : !_vm.loading
          ? _c(
              "div",
              { staticClass: "empty-state" },
              [
                _c("a-empty", {
                  attrs: {
                    description:
                      "Veri bulunamadı. Lütfen tarih aralığını kontrol edin.",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }